import { styled } from '@mui/material/styles';

export const LayoutStyled = styled('div')`
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
